import { Text } from '@thefarmersfront/kitchen';

import { DonutChart } from '~/components/common/chart/DonutChart';

import { formatNumber } from '~/utils/common';

import { SummaryItem } from '../SummaryItem';

import styles from './DeliveryAgencyDeliveryStatusTotalShippingLabels.module.scss';

interface DeliveryAgencyDeliveryStatusTotalShippingLabelsProps {
  totalCount: number;
  nightDeliveryCount: number;
  dawnDeliveryCount: number;
  dayDeliveryCount: number;
}

const DeliveryAgencyDeliveryStatusTotalShippingLabels = ({
  totalCount,
  nightDeliveryCount,
  dawnDeliveryCount,
  dayDeliveryCount,
}: DeliveryAgencyDeliveryStatusTotalShippingLabelsProps) => {
  return (
    <div className={styles.container}>
      <SummaryItem title="배송 요청">
        <DonutChart
          value={formatNumber(totalCount)}
          suffix="건"
          segments={[
            { value: nightDeliveryCount, color: '#4EB595' },
            { value: dawnDeliveryCount, color: '#BD76FF' },
            { value: dayDeliveryCount, color: '#5094DC' },
          ]}
          labelFontStyle={{ fontSize: 24, fontWeight: 700 }}
          suffixFontStyle={{ fontSize: 24, fontWeight: 700, dx: 0, dy: 0 }}
        />
        <div className={styles['label-group']}>
          <div className={styles.label}>
            <div className={styles['label-dot--night']} />
            <Text size="large" weight="regular">
              당일배송: {formatNumber(nightDeliveryCount)}
            </Text>
          </div>
          <div className={styles.label}>
            <div className={styles['label-dot--dawn']} />
            <Text size="large" weight="regular">
              새벽배송: {formatNumber(dawnDeliveryCount)}
            </Text>
          </div>
          <div className={styles.label}>
            <div className={styles['label-dot--day']} />
            <Text size="large" weight="regular">
              하루배송(택배): {formatNumber(dayDeliveryCount)}
            </Text>
          </div>
        </div>
      </SummaryItem>
    </div>
  );
};

export { DeliveryAgencyDeliveryStatusTotalShippingLabels };
